<template>
	<div class="page">
		<nav-bar />
		<div class="search">
			<div class="inputBox">
				<select :value="searchData.month" v-model="searchData.month" @change="changeMonth">
					<option v-for="(val, key) in month" :value="val?.value">{{ val?.key }}</option>
				</select>
				<van-field v-model="searchData.keywords" placeholder="请输入关键字" :clearable="true" @keyup.enter="search" />
				<img src="@/assets/images/search.png" class="searchIcon" @click.stop="search" />
			</div>
		</div>
		<div class="main">
			<van-list class="list" v-model="loading" :finished="finished" loading-text="加载更多" finished-text="没有更多了" :immediate-check="false" :offset="80" @load="onLoad">
				<li class="item" v-for="(item, index) in list" :key="index" @click.stop="onClick(item, index)">
					<div class="cover">
						<img v-if="item?.cover" :src="item?.cover" />
					</div>
					<div class="name ellipsis3" v-html="$highlightTitle(item?.title || ``, keywords || ``) || `暂无名称`"></div>
					<div class="foot">
						<div class="time" v-text="getTime(item?.created_at) || `暂无时间`"></div>
						<img src="@/assets/images/arrow.png" class="rightIcon" />
					</div>
				</li>
			</van-list>
		</div>

		<!--悬浮按钮-->
		<drag-view>
			<div class="float-button" @click.stop="survey">
				<img src="@/assets/images/edit.png" />
				<div>
					填问卷
					<p></p>
					得积分
				</div>
			</div>
		</drag-view>
	</div>
</template>

<script>
import { Toast, Field, List, Empty } from 'vant';
import NavBar from '@/components/NavBar.vue';
import DragView from '@/components/DragView.vue';
export default {
	components: {
		NavBar,
		DragView,
		[Field.name]: Field,
		[List.name]: List,
		[Empty.name]: Empty
	},
	data() {
		return {
			keywords: ``,
			searchData: {
				keywords: ``,
				month: `月份`
			},
			month: [
				{ key: `月份`, value: `月份` },
				{ key: `12月`, value: 12 },
				{ key: `11月`, value: 11 },
				{ key: `10月`, value: 10 },
				{ key: `9月`, value: 9 },
				{ key: `8月`, value: 8 },
				{ key: `7月`, value: 7 },
				{ key: `6月`, value: 6 },
				{ key: `5月`, value: 5 },
				{ key: `4月`, value: 4 },
				{ key: `3月`, value: 3 },
				{ key: `2月`, value: 2 },
				{ key: `1月`, value: 1 }
			],
			current: 1,
			pageSize: 3,
			total: 0,
			loading: false,
			finished: false,
			list: [],
			tips: null
		};
	},
	created() {},
	mounted() {
		this.initShare();
		this.$dataStatistics({ event_type: 'view', page_title: '搜索' }, ``);

		this.getList(true);
	},
	methods: {
		onLoad() {
			if (this.list?.length < this.total) {
				this.current++;
			} else {
				return;
			}
			this.getList();
		},
		search() {
			let data = {
				keywords: this.searchData?.keywords,
				month: this.searchData?.month == '月份' ? '' : this.searchData?.month
			};
			this.$dataStatistics({ event_type: 'click', page_title: `${this.searchData?.keywords?.length > 0 ? `搜索-内容` : `清空搜索`}` }, `${JSON.stringify(data)}`);

			this.tips = Toast.loading({ message: '搜索中...', forbidClick: true, overlay: true, forbidClick: true });
			this.getList(true);
			this.$nextTick(() => {
				this.keywords = JSON.parse(JSON.stringify(this.searchData?.keywords));
			});
		},
		getList(key = false) {
			if (key) {
				this.finished = false;
				this.current = 1;
				this.total = 0;
				this.list = [];
			}
			this.loading = true;
			this.$http
				.get(`/platform/periods`, {
					params: {
						'filter[type]': this.$route.query?.type,
						'filter[time]': this.searchData?.month == '月份' ? null : this.searchData?.month,
						'filter[keyword]': this.searchData?.keywords || ``,
						pageSize: this.pageSize,
						current: this.current
					}
				})
				.then((res) => {
					let list = res?.data?.data;
					this.current = res?.data?.current;
					this.total = res?.data?.total;
					if (key) {
						this.list = list;
					} else {
						this.list = this.list.concat(list);
					}

					this.$nextTick(() => {
						this.loading = false;
						if (this.list?.length >= this.total) {
							this.finished = true;
						}
						this.tips?.clear();
					});
				});
		},
		changeMonth(e) {},
		onClick(item, index) {
			let data = { title: item?.title, id: item?.id };
			this.$dataStatistics({ event_type: 'click', page_title: `搜索列表-跳转` }, `${JSON.stringify(data)}`);
			Toast('敬请期待');
		}
	}
};
</script>
<style lang="less" scoped>
.page {
	background: #fafafa;

	.search {
		width: 828px;
		height: 138px;
		box-shadow: @box-shadow;
		background-color: #fff;
		padding: 0 36px;
		display: flex;
		align-items: center;

		.inputBox {
			width: 100%;
			height: 75px;
			border-radius: @border-radius;
			border: 1.5px solid #cccccc;
			display: flex;
			align-items: center;
			overflow: hidden;
			position: relative;

			select {
				height: 100%;
				border: none;
				margin-right: 20px;
				margin-left: 23px;
				font-weight: 400;
				font-size: 32px;
				color: #333333;
				line-height: 32px;
				background-color: transparent;
			}

			/deep/.van-cell {
				height: 100%;
				background-color: transparent;
				padding: 0 26px;
				margin-right: 52px;
				border-left: 1.5px solid #ccc;

				.van-field__body {
					width: 100%;
					height: 100%;
				}

				input {
					width: 100%;
					height: 100%;
					font-weight: 400;
					font-size: 32px;

					&::placeholder {
						color: #999999;
					}
				}
			}

			.searchIcon {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				z-index: 1;
				width: 32px;
				height: 32px;
				padding: 16px;
				box-sizing: content-box;
			}
		}
	}

	.main {
		padding: 36px;

		& .list {
			& .item {
				box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.06);
				border-radius: @border-radius;
				background-color: #fff;
				overflow: hidden;
				margin-bottom: 30px;
				padding: 30px 28px 32px;
				border-bottom: 1.5px solid #e7e6e6;

				.cover {
					width: 100%;
					height: 286px;
					margin-bottom: calc(30px + ((46px - 30px) / 2 * -1));

					img {
						width: 100%;
						height: 100%;
						display: block;
						object-fit: cover;
					}
				}

				.name {
					font-weight: 400;
					font-size: 30px;
					color: #333333;
					line-height: 46px;
					margin-bottom: calc(24px + ((46px - 30px) / 2 * -1));
				}

				.foot {
					display: flex;
					align-items: center;
					justify-content: space-between;

					.time {
						font-weight: 400;
						font-size: 28px;
						color: #626469;
						line-height: 1;
					}

					.rightIcon {
						width: 27px;
						height: 20px;
						display: block;
					}
				}
			}
		}
	}
}
</style>
